export default "/directory/static/brings_pa_equipment.ae8d4269.svg";